import { useAuth } from '@shared/auth';
import { ErrorBox, Loading } from '@shared/components';
import { useGetAppRoleQuery } from '@user-management/graphql';
import { createContext, useMemo } from 'react';

import mapAppRoleData from './mapper';
import type { RoleContextValue, RoleProviderProps } from './types';

const RoleContext = createContext<RoleContextValue | undefined>(undefined);

export default function RoleProvider(props: Readonly<RoleProviderProps>) {
  const { appRoleId, children } = props;

  const {
    data,
    loading: isLoading,
    error,
  } = useGetAppRoleQuery({
    variables: { appRoleId },
  });

  const auth = useAuth();

  const appRoles = auth?.userProfile?.appRoles ?? [];

  const contextValue: RoleContextValue = useMemo(() => {
    return {
      appRoleData: mapAppRoleData(data?.suGetAppRole),
      isMyRole: appRoles.includes(data?.suGetAppRole.name ?? ''),
    };
  }, [data, appRoles]);

  if (isLoading) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  if (error) {
    return <ErrorBox />;
  }

  return <RoleContext.Provider value={contextValue}>{children}</RoleContext.Provider>;
}

export { RoleContext };
